module.exports = __webpack_public_path__ + "img/s3.68c3147b.svg";